import validateVar from "./validation/validateVariable";


export default function is_spot(tariff_type) {
    return validateVar(tariff_type) && tariff_type === "SPOT";
}
